/* eslint-disable react/prop-types */
import React, { useState } from "react";
import {
  Card,
  Grid,
  Avatar,
  Pagination,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { useSoftUIController } from "context";
import { useNavigate } from "react-router-dom"; 

const reportees = [

{
    id: 1,
    name: "Lilly Williams",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/1.jpg",
  },
  {
    id: 2,
    name: "Clarkson Walter",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/men/2.jpg",
  },
  {
    id: 3,
    name: "Sophia Johnson",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/3.jpg",
  },
  {
    id: 4,
    name: "Michael Brown",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/men/4.jpg",
  },
  {
    id: 5,
    name: "Emma Wilson",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/5.jpg",
  },
  {
    id: 6,
    name: "James Smith",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/men/6.jpg",
  },
  {
    id: 7,
    name: "Olivia Taylor",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/7.jpg",
  },
  {
    id: 8,
    name: "Liam Anderson",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/men/8.jpg",
  },
  {
    id: 9,
    name: "Ava Martinez",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/9.jpg",
  },
  {
    id: 10,
    name: "Noah Garcia",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/men/10.jpg",
  },
  {
    id: 11,
    name: "Emma Davis",
    shift: "General",
    shiftTime: "9:00 AM - 6:00 PM",
    salary: "$500",
    weekend: true,
    image: "https://randomuser.me/api/portraits/women/11.jpg",
  },
];

const MainBox = styled("div")(({ theme }) => ({
  display: "flex",
}));

const ContentBox = styled("main")(({ theme }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: "margin-left 0.3s ease-in-out",
}));

function SalaryTeam () {
  const [controller] = useSoftUIController();
  const { miniSidenav } = controller;
  const navigate = useNavigate(); 
  const [page, setPage] = useState(1);
  const itemsPerPage = 8;

  const paginatedReportees = reportees.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

    const [activeTopTab, setActiveTopTab] = useState("My Data");
    const [activeDataTab, setActiveDataTab] = useState("Pre Payment");

  return (
    <MainBox>
      <ContentBox>
        <Grid container spacing={3}>
          {paginatedReportees.map((user) => (
            <Grid item xs={12} sm={6} md={3} key={user.id}>
              <Card
                sx={{
                  p: 2,
                  height: "100%",
                  borderRadius: 3,
                  cursor: "pointer",
                  transition: "transform 0.2s",
                  "&:hover": { transform: "scale(1.02)", boxShadow: 4 },
                }}
    //             onClick={() => {setActiveTopTab("My Data");
    //   setActiveDataTab("Pre Payment"); 
    //  navigate(`/leavesummary/${user.id}`) }} 
                onClick={() => {
  navigate(`/salary/${user.id}`, {
    state: { tab: "My Data", dataTab: "Pre Payment" }, // pass tab states
  });
}}

              >
                <SoftBox display="flex" alignItems="center" mb={1}>
                  <Avatar src={user.image} sx={{ width: 48, height: 48, mr: 2 }} />
                  <SoftTypography variant="h6">{user.name}</SoftTypography>
                </SoftBox>
                {user.weekend && (
                  <SoftTypography
                    variant="caption"
                    color="black"
                    fontWeight="medium"
                    mb={1}
                  >
                    {user.salary}
                  </SoftTypography>
                )}
                <SoftBox display="flex" alignItems="center" gap={1} mt={1}>
                  <Typography variant="button" color="text" fontWeight="regular">
                    {user.shift} - {user.shiftTime}
                  </Typography>
                </SoftBox>
              </Card>
            </Grid>
          ))}
        </Grid>

        <SoftBox display="flex" justifyContent="center" mt={4}>
          <Pagination
            count={Math.ceil(reportees.length / itemsPerPage)}
            page={page}
            onChange={(_, value) => setPage(value)}
            color="primary"
          />
        </SoftBox>
      </ContentBox>
    </MainBox>
  );
};

export default SalaryTeam;
